import { ILaya } from "../../ILaya";
import { Loader } from "../net/Loader";
import { Resource } from "./Resource";
export class Prefab extends Resource {
    constructor() {
        super(false);
        this.fromDCC = false;
        this._traceDeps = true;
    }
    onLoad() {
        Resource._idResourcesMap[this._id] = this;
        return this;
    }
    create(options, errors) {
        return null;
    }
    static instantiate(url, classType) {
        return ILaya.loader.load(url, Loader.HIERARCHY).then((res) => {
            return res.create();
        });
    }
}
export var HierarchyResource = Prefab;
